export const useGetRiskColor = (risk: number) => {
  if (risk === 1) return '#B3F28D';
  if (risk === 2) return '#D6FEA4';
  if (risk === 3) return '#FF9';
  if (risk === 4) return '#FC6';
  if (risk === 5) return '#F19E9C';
  return 'none';
};
